export const sidebar = {
  paddingTop: 70,
  width: 250,
}
